/* Dialog Text */
import { Component, Inject } from "@angular/core";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import {
  ReportEmbeddedType,
  ReportSubscriptionType,
  ReportStandardType,
} from "../../../api/models";
import {
  TextEditDialogData,
  TextEditDialogComponent,
} from "../../text-edit-dialog/text-edit-dialog.component";

export interface EditReportSubscriptionTypeDialogData {
  dialogTitle: string;
  isNew: boolean;
  reportSubscriptionType: ReportSubscriptionType;
  reportStandardTypes: ReportStandardType[];
  reportEmbeddedTypes: ReportEmbeddedType[];

  selectedReportStandardTypes: ReportStandardType[];
  selectedReportEmbeddedTypes: ReportEmbeddedType[];
}

@Component({
  selector: "edit-report-subscription-type-dialog",
  styleUrls: ["edit-report-subscription-type-dialog.component.css"],
  templateUrl: "./edit-report-subscription-type-dialog.component.html",
})
export class EditReportSubscriptionTypeDialogComponent {
  public Result: DialogResult;
  public selectedReportStandardType: ReportStandardType = null;
  public selectedReportEmbeddedType: ReportEmbeddedType = null;
  public isLoading: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<EditReportSubscriptionTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: EditReportSubscriptionTypeDialogData,
    private dialog: MatDialog
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {
    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.data;
    this.dialogRef.close(this.Result);
  }

  onAddStandardType() {
    let wasFound = false;
    for (var i = 0; i < this.data.selectedReportStandardTypes.length; i++) {
      if (this.data.selectedReportStandardTypes[i].reportStandardTypeId == this.selectedReportStandardType.reportStandardTypeId) {
        wasFound = true;
      }
    }

    if (!wasFound) {
      this.data.selectedReportStandardTypes.push(this.selectedReportStandardType);
    }
  }

  onRemoveStandardType(stdType: ReportStandardType) {
    var selectedIndex = -1;
    for (var i = 0; i < this.data.selectedReportStandardTypes.length; i++) {
      if (this.data.selectedReportStandardTypes[i].reportStandardTypeId == stdType.reportStandardTypeId) {
        selectedIndex = i;
        break;
      }
    }

    if (selectedIndex != -1) {
      this.data.selectedReportStandardTypes.splice(selectedIndex, 1);
    }
  }

  onAddEmbeddedType() {
    let wasFound = false;
    for (var i = 0; i < this.data.selectedReportEmbeddedTypes.length; i++) {
      if (this.data.selectedReportEmbeddedTypes[i].reportEmbeddedTypeId == this.selectedReportEmbeddedType.reportEmbeddedTypeId) {
        wasFound = true;
      }
    }

    if (!wasFound) {
      this.data.selectedReportEmbeddedTypes.push(this.selectedReportEmbeddedType);
    }
  }

  onRemoveEmbeddedType(stdType: ReportEmbeddedType) {
    var selectedIndex = -1;
    for (var i = 0; i < this.data.selectedReportEmbeddedTypes.length; i++) {
      if (this.data.selectedReportEmbeddedTypes[i].reportEmbeddedTypeId == stdType.reportEmbeddedTypeId) {
        selectedIndex = i;
        break;
      }
    }

    if (selectedIndex != -1) {
      this.data.selectedReportEmbeddedTypes.splice(selectedIndex, 1);
    }
  }

  editLicense() {
    var params: TextEditDialogData = {
      title: "Add / Edit License",
      prompt: "Enter license HTML below",
      data: this.data.reportSubscriptionType.licenseHtml,
    };

    var dialogRef = this.dialog.open(TextEditDialogComponent, {
      width: "500px",
      data: params,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (
        result != null &&
        result.ResultType != null &&
        result.ResultType == DialogResultType.Ok
      ) {
        this.data.reportSubscriptionType.licenseHtml = result.ResultData;
      }
    });
  }
}
